// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HolidaySelectionModalStyles {
  text-align: center;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 32px 26px 24px 26px;
  width: 328px;
  height: 205px;
  z-index: 1000;
  background: #ffffff;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
  border-radius: 12px;
}
.HolidaySelectionModalStyles .header {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: #333333;
  margin-bottom: 12px;
}
.HolidaySelectionModalStyles .description {
  text-align: center;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #505054;
}
.HolidaySelectionModalStyles .buttonRow {
  display: flex;
  align-content: space-between;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  margin-top: 28px;
  text-align: center;
  align-content: center;
  width: 100%;
  position: relative;
  top: 20px;
}
.HolidaySelectionModalStyles .buttonRow button {
  width: 100%;
  height: 40px;
  border: none;
  border-radius: 8px;
  background: #075453;
  color: white;
}

.HolidaySelectionModalOverlayStyles {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1000;
}`, "",{"version":3,"sources":["webpack://./src/screens/workingTemplate/holidaySelectionModal/holidaySelectionModal.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,4BAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,4CAAA;EACA,mBAAA;AACJ;AAAI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AAER;AAAI;EACI,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAER;AAAI;EACI,aAAA;EACA,4BAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;AAER;AAAQ;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AAEZ;;AAGA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;AAAJ","sourcesContent":[".HolidaySelectionModalStyles {\n    text-align: center;\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    padding: 32px 26px 24px 26px;\n    width: 328px;\n    height: 205px;\n    z-index: 1000;\n    background: #ffffff;\n    box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n    border-radius: 12px;\n    .header {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 18px;\n        line-height: 24px;\n        text-align: center;\n        color: #333333;\n        margin-bottom: 12px;\n    }\n    .description {\n        text-align: center;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n        text-align: center;\n        color: #505054;\n    }\n    .buttonRow {\n        display: flex;\n        align-content: space-between;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px;\n        margin-top: 28px;\n        text-align: center;\n        align-content: center;\n        width: 100%; \n        position: relative;\n        top:20px;\n\n        button {\n            width: 100%;\n            height: 40px;\n            border: none; \n            border-radius: 8px;\n            background: #075453;\n            color: white;\n        }\n    }\n}\n\n.HolidaySelectionModalOverlayStyles {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.7);\n    z-index: 1000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
